<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="80px">
    <el-form-item label-width="100px" prop="title" label="文章标题">
      <el-col :span="8">
        <el-input v-model="form.title" placeholder="请输入文章标题"></el-input>
      </el-col>
    </el-form-item>
    <el-form-item label-width="100px" prop="expRelTime" label="设置发布时间">
      <el-col :span="8">
        <el-date-picker
          type="datetime"
          placeholder="设置预计发布时间（可不选）"
          v-model="form.expRelTime"
          style="width: 100%;"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-col>
    </el-form-item>
    <el-form-item label-width="100px" prop="writeTime" label="编写时间">
      <el-col :span="8">
        <el-date-picker
          type="date"
          placeholder="设置预计发布时间"
          v-model="form.writeTime"
          style="width: 100%;"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-col>
    </el-form-item>
    <el-form-item label-width="100px" prop="typeId" label="文章类别">
      <div class="type-box">
        <el-radio
          v-for="(item,index) in types"
          :key="index"
          v-model="form.typeId"
          :label="item.id"
        >{{ item.name }}</el-radio>
      </div>
    </el-form-item>
    <el-form-item label-width="100px" prop="content" label="文章内容">
      <el-col :span="12">
        <div ref="editorTool"></div>
        <div ref="editorElem" class="edite-main"></div>
      </el-col>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import E from "wangeditor";
import qs from "qs";
import { addNews, artTyple, getArticleById, editArticle } from "@/axios/api.js";
import { convertCase } from '@/axios/util'
export default {
  data() {
    return {
      editor: null,
      editorContent: "",
      types: [],
      form: {
        title: "",
        expRelTime: "",
        typeId: "",
        content: "",
        writeTime: ""
      },
      editStatus: false,
      rules: {
        title: [{ required: true, message: "请输入文章标题", trigger: "blur" }],
        expRelTime: [{ required: false }],
        typeId: [
          { required: true, message: "请至少选择一个类别", trigger: "change" }
        ],
        content: [
          { required: true, message: "请输入文章内容", trigger: "blur" }
        ],
        writeTime: [
          { required: true, message: "请选择编写时间", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(validate => {
        if (!this.editStatus) {
          addNews(this.form).then(res => {
            if (res.status) this.$message.success("保存成功");
          });
        } else {
          editArticle(this.form).then(res => {
            if (res.status) {
              this.$message.success("保存成功");
              this.handleGetArticleById(this.form.id);
            }
          });
        }
      });
    },
    getArtTyple() {
      artTyple().then(res => {
        if (res.status === 200) this.types = res.data;
      });
    },
    handleGetArticleById(id) {
      getArticleById(id).then(res => {
        if (res.status === 200) {
          this.form = res.data;
          this.form.id = id;
          this.editor.txt.html(res.data.content);
          this.editStatus = true;
        }
      });
    }
  },
  mounted(option) {
    this.getArtTyple();
    this.editor = new E(this.$refs.editorTool, this.$refs.editorElem);
    this.editor.customConfig.onchange = html => {
      this.form.content = html;
    };
    this.editor.customConfig.menus = [
      // 菜单配置
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      "link", // 插入链接
      "list", // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "emoticon", // 表情
      "image", // 插入图片
      "table", // 表格
      "code", // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];
    this.editor.customConfig.uploadImgServer = "/admin/file/upload/image";
    this.editor.customConfig.uploadFileName = "file";
    this.editor.customConfig.zIndex = 0;


    let cah = localStorage.getItem("admin");
    let user;
    if (cah) {
      cah = convertCase(cah).split('').reverse().join('');
      user = qs.parse(atob(cah));
    }
    
    this.editor.customConfig.uploadImgHeaders = {
      access_token: user.token
    };
    //插入本地图片
    this.editor.customConfig.uploadImgHooks = {
      customInsert: (insertImg, result, editor) => {
        if(result.status === 200){
          insertImg(result.data);
        }else{
          this.$message.error("登录超时，请退出系统重新登录!");
        }
        
      }
    };
    //使用网络图片
    this.editor.customConfig.linkImgCallback = function(url) {
      insertImg(url); // url 即插入图片的地址
    };
    this.editor.create();
    this.editor.txt.html("<p>请输入文章内容</p>");
    let query = qs.parse(this.$route.query);
    if (query.id - 0 > 0) {
      this.handleGetArticleById(query.id);
    }
  }
};
</script>

<style>
.type-box {
  /* display: flex;
  flex-direction: row;
  align-items: center; */
  height: auto;
  width: 880px;
  text-align: left;
}
.edite-main {
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  height: 700px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/views/news/NewsEdit.vue